module.exports = __webpack_public_path__ + "img/ajay-pro.0985ffbf.jpg";